import { FrenchFriesIcon } from './FrenchFriesIcon';

/**
 * author: Colton Wiscombe
 * id C7BD4B3A-4B63-4FDE-99D5-87B4DA460492
 * name french-fries
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/french-fries.svg
 * tags
 * - Food / Drink 
 */
export const FritesIcon = FrenchFriesIcon;
export default FritesIcon